import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { hotMovies } from '@/mocks/movies';

export default function HotMoviesSection() {
  const displayMovies = hotMovies.slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门电影
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              精选高分电影，蓝光画质1080P在线观看
            </p>
          </div>
          <Link
            to="/category/action"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {displayMovies.map((movie) => (
            <MovieCard
              key={movie.id}
              id={movie.id}
              title={movie.title}
              year={movie.year}
              rating={movie.rating}
              genre={movie.genre}
              quality={movie.quality}
              imageUrl={movie.imageUrl}
              isHot={movie.isHot}
              isNew={movie.isNew}
              linkTo={`/category/action`}
            />
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/action"
            className="inline-flex items-center gap-1 px-6 py-2 text-sm font-medium text-primary-500 border border-primary-200 rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部电影
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}